(function () {
    'use strict';

    angular.module('app').directive('preventDefaultClick', PreventDefaultClickAttribute);
    function PreventDefaultClickAttribute() {
        return {
            restrict: 'A',
            link: function (_scope, elem) {
                elem.on('click', e => { e.preventDefault(); });
            }
        };
    }
})();